






import { Component, Prop, Vue } from 'vue-property-decorator';
import { FieldNormalizer } from '@/classes/normalizers/types';

@Component
export default class ObjectField extends Vue {
  @Prop()
  value!: any;

  @Prop({
    default: false,
  })
  disabled!: boolean;

  @Prop()
  normalizer!: FieldNormalizer;

  get chosenItem() {
    if (!this.normalizer) {
      return this.value;
    }
    return this.value ? this.normalizer.reverseNormalize(this.value) : '';
  }

  onChange(value: any) {
    if (this.normalizer) {
      value = this.normalizer.normalize(value);
    }

    this.$emit('input', value);
  }
}
